import React, { useState } from 'react';
import "./Contact.css";


export default function ContactWrapper({ children }) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="contact-wrapper-container">
      <div className="button-trigger" onClick={() => setIsVisible(!isVisible)}>
        {children}
      </div>

      {isVisible && (
        <div className="contact-info-box">
          <p>تماس جهت هماهنگی:</p>
          <a href="tel:+989377656917">09377656917</a>
        </div>
      )}
    </div>
  );
}


